// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2LVQU","messages":"Chat_messages__3NAla","dateDivider":"Chat_dateDivider__1Lfcq"};